import React from "react";
import { Carousel } from "antd";
import styled from "styled-components";

import Image1 from "../../../assets/images/desktop-banner.png";
import Image2 from "../../../assets/images/mobile-banner.png";

const CustomCarousel = () => (
  <Wrapper>
      <div className="banner-desktop">
        <img src={Image1} alt="Slide 1" />
      </div>
      <div className="banner-mobile">
        <img src={Image2} alt="Slide 1" />
      </div>
  </Wrapper>
);

export default CustomCarousel;

const Wrapper = styled.div`
  width: 100%;
  position: relative;

  .banner-desktop {
    text-align: center;
    overflow: hidden;
    
  }
  @media (max-width: 899px) {
      .banner-desktop {
          display: none;
      }
  }

  .banner-mobile {
    text-align: center;
    overflow: hidden;
    
  }
  @media (min-width: 900px) {
      .banner-mobile {
          display: none;
      }
  }

  .banner-desktop img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }

  .banner-mobile img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }

  .slick-prev,
  .slick-next {
    width: 30px;
    height: 30px;
    z-index: 10;
    top: 50%;
    transform: translateY(-50%);
  }

  .slick-prev {
    left: 20px;
  }

  .slick-next {
    right: 20px;
  }

  .slick-prev:before,
  .slick-next:before {
    font-size: 24px;
    opacity: 0.7;
  }

  .slick-dots li button:before {
    font-size: 10px;
    color: #ccc;
    opacity: 1;
  }

  .slick-dots li.slick-active button:before {
    color: #00bcd4;
  }

  element.style {
    display: block;
    width: 100%;
  }

  .ant-carousel .slick-dots {
    position: absolute;
    right: 0;
    bottom: 30px;
    left: 0;
    z-index: 15;
    display: flex !important;
    justify-content: center;
    margin-right: 0%;
    margin-left: 0%;
    padding-left: 0;
  }

  .ant-carousel .slick-slider .slick-list {
    height: 260px;
    border-radius: 10px;
  }
`;
